import React from 'react'
import KeyTermFilters from './KeyTermFilters'
import RenderTermData from './RenderTermData'

export default function KeyTermBox() {
  
    const containerStyles={
        width:'100%',
        border: '1px solid #E0E2E6',
        borderRadius:'12px',
        background:'#FFFFFF',
        boxShadow: '0px 4px 16px 0px #1018280F',
        padding:'24px'
    }
  return (
    <div style={containerStyles}>
        <KeyTermFilters/>
        <RenderTermData/>
    </div>
  )
}
